import { TouchableWithoutFeedback, View } from 'react-native'
import React, { ReactNode } from 'react'
import { useTheme } from '@ui-kitten/components'
import { StyleService, useStyleSheet } from '@style/service.ts'
import { Icon, Text } from '@components/base'

interface MyPlanCardProps {
  leftAccessory: ReactNode
  primaryText: string
  secondaryText: string
  handleOnPress: () => void
}

export const MyPlanCard = ({
  leftAccessory,
  primaryText,
  secondaryText,
  handleOnPress,
}: MyPlanCardProps) => {
  const theme = useTheme()
  const styles = useStyleSheet(themedStyle)

  return (
    <TouchableWithoutFeedback accessibilityLabel="My Plan" onPress={handleOnPress}>
      <View>
        <View style={styles.contentContainer}>
          <View style={styles.leftAccessoryContainer}>{leftAccessory}</View>

          <View style={{ flex: 1 }}>
            <Text type="large" bold>
              {primaryText}
            </Text>
            <Text type="regular" style={styles.noteText}>
              {secondaryText}
            </Text>
          </View>
        </View>

        <Icon
          name="caret-right"
          size={18}
          color={theme['theme.primary.base']}
          style={styles.icon}
        />
      </View>
    </TouchableWithoutFeedback>
  )
}

const themedStyle = StyleService.create({
  noteText: {
    color: 'theme.text.secondary',
    maxWidth: 260,
  },
  contentContainer: {
    flexDirection: 'row',
    gap: 16,
  },
  icon: {
    position: 'absolute',
    top: 34,
    right: 12,
  },
  leftAccessoryContainer: {
    width: 48,
    height: 48,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'theme.surface.base3',
    borderRadius: 100,
    alignSelf: 'center',
  },
})
